// extracted by mini-css-extract-plugin
export default {"tagcloud-wrapper":"TagCloud_tagcloud-wrapper__PfjvX","tagcloud-popover-trigger":"TagCloud_tagcloud-popover-trigger__x542K"};